import { all, call, take, race } from 'redux-saga/effects';
import { initLayoutSaga } from 'sagas/monitoring/layoutSagas';

export function* initializeSessionWatcher() {
    while (true) {
        const { logout } = yield race({
            allLoaded: all([
                take('LOGIN_SUCCESS'),
                take('DEVICES_LOAD_SUCCESS'),
                take('DEVICEGROUPS_LOAD_SUCCESS'),
            ]),
            logout: take('LOGOUT'),
        });

        if (logout) {
            continue;
        }

        // User session has been loaded.
        yield call(postInitSessionSaga);
    }
}

export function* postInitSessionSaga() {
    yield all([
        call(initLayoutSaga),

        // Add other post-init tasks here
    ]);
}



// WEBPACK FOOTER //
// ./src/sagas/app/postInitSessionSaga.ts